import { render, staticRenderFns } from "./BadgeList.vue?vue&type=template&id=1c4efaca&scoped=true&"
import script from "./BadgeList.vue?vue&type=script&lang=js&"
export * from "./BadgeList.vue?vue&type=script&lang=js&"
import style0 from "./BadgeList.vue?vue&type=style&index=0&id=1c4efaca&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4efaca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
